export class FixSqlQueryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlQueryExecutionId",
            "baseName": "sqlQueryExecutionId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return FixSqlQueryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
